import cx from 'clsx';
import React, { forwardRef } from 'react';

const Flex = forwardRef((props, ref) => {
  const { style, className, row, column, center, children, ...reset } = props;

  let direction = 'flex-row';
  if (!row && column) {
    direction = 'flex-col';
  }

  return (
    <div
      {...reset}
      ref={ref}
      style={{
        ...style,
      }}
      className={cx(
        'flex',
        direction,
        { 'items-center justify-center': center },
        className
      )}
    >
      {children}
    </div>
  );
});

export default Flex;
